import gql from 'graphql-tag';

export const NAME = 'compositions_CaseActivityPanel_Notes_caseNotesQuery';

export default gql`
  query ${NAME} (
    $caseNumber: String!
  ) {
    case (
      caseNumber: $caseNumber
    ) {
      id
      notes {
        edges {
          node {
            author {
              email
              name
            }
            body
            createdAt
            id
            lastUpdatedBy {
              email
              name
            }
            updatedAt
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/Notes/withCaseNotes/caseNotesQuery.js